import { create } from 'zustand'

type Store = {
  email: string
  setEmail: (email: string) => void
  reset: () => void
}

export const useEmailAuthStore = create<Store>(set => ({
  email: '',
  setEmail(email) {
    set({ email })
  },
  reset() {
    set({ email: '' })
  },
}))
